import React from "react"

const AboutInfo = () => {
  return (
    <div className="display">
      <div className="container">
        <div className="inner-display">
          <div className="wrap" style={{ marginBottom: 20 }}>
            <h1>About </h1>
            <ul>
              <li>
                <p>A world of Knowledge at your fingure.</p>
              </li>

              <li>
                <p>Learning together from the comfort of your home.</p>
              </li>
              <li>
                <p>A solution of every need.</p>
              </li>
            </ul>
          </div>
          <div className="wrap">
            <h1>Services</h1>
            <p>Our Expert will guide</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutInfo
